import * as Yup from "yup";
import {
  campo_obligatorio,
  las_contrasenas_deben_coincidir,
  debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres,
} from "../../utils/traductor";

export function initialValues() {
  return {
    password: "",
    passwordRepetir: "",
  };
}

export function validationSchema() {
  return Yup.object({
    password: Yup.string().required(` ${campo_obligatorio} `),
    passwordRepetir: Yup.string()
      .required(` ${campo_obligatorio} `)
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
        debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres
      )
      .oneOf([Yup.ref("password")], ` ${las_contrasenas_deben_coincidir} `),
  });
}
